'use strict';

module.exports = require('./Loading');